export const dataNivel = [
    { "position": 1, "codigo": 'INICIAL I', "nivel": 'Inicial I' },
    { "position": 2, "codigo": 'INICIAL II', "nivel": 'Inicial II' },
    {"position": 3, "codigo": '1RO BASICA', "nivel": 'Primero de Básica' },
    {"position": 4, "codigo": '2DO BASICA', "nivel": 'Segundo de Básica' },
    {"position": 5, "codigo": '3RO BASICA', "nivel": 'Tercero de Básica' },
    {"position": 6, "codigo": '4TO BASICA', "nivel": 'Cuarto de Básica' },
    {"position": 7, "codigo": '5TO BASICA', "nivel": 'Quinto de Básica' },
    {"position": 8, "codigo": '6TO BASICA', "nivel": 'Sexto de Básica' },
    {"position": 9, "codigo": '7MO BASICA', "nivel": 'Séptimo de Básica' },
    {"position": 10, "codigo": '8VO BASICA', "nivel": 'Octavo de Básica' },
    {"position": 11, "codigo": '9NO BASICA', "nivel": 'Noveno de Básica' },
    {"position": 12, "codigo": '10MO BASICA', "nivel": 'Décimo de Básica' },
    {"position": 13, "codigo": '1RO BACHILLERATO', "nivel": 'Primero de Bachillerato' },
    {"position": 14, "codigo": '2DO BACHILLERATO', "nivel": 'Segundo de Bachillerato' },
    {"position": 15, "codigo": '3RO BACHILLERATO', "nivel": 'Tercero de Bachillerato' },
   
  ];


  

  export const dataNivelSEK = [
    { "position": 1, "codigo": 'INICIAL I', "nivel": 'Inicial I' },
    { "position": 2, "codigo": 'INICIAL II', "nivel": 'Inicial II (3 Años )' },
    { "position": 3, "codigo": 'INICIAL II', "nivel": 'Inicial II (4 Años )' },
    {"position": 4, "codigo": '1RO BASICA', "nivel": 'Primero de Básica' },
    {"position": 5, "codigo": '2DO BASICA', "nivel": 'Segundo de Básica' },
    {"position": 6, "codigo": '3RO BASICA', "nivel": 'Tercero de Básica' },
    {"position": 7, "codigo": '4TO BASICA', "nivel": 'Cuarto de Básica' },
    {"position": 8, "codigo": '5TO BASICA', "nivel": 'Quinto de Básica' },
    {"position": 9, "codigo": '6TO BASICA', "nivel": 'Sexto de Básica' },
    {"position": 10, "codigo": '7MO BASICA', "nivel": 'Séptimo de Básica' },
    {"position": 11, "codigo": '8VO BASICA', "nivel": 'Octavo de Básica' },
    {"position": 12, "codigo": '9NO BASICA', "nivel": 'Noveno de Básica' },
    {"position": 13, "codigo": '10MO BASICA', "nivel": 'Décimo de Básica' },
    {"position": 14, "codigo": '1RO BACHILLERATO', "nivel": 'Primero de Bachillerato' },
    {"position": 15, "codigo": '2DO BACHILLERATO', "nivel": 'Segundo de Bachillerato' },
    {"position": 16, "codigo": '3RO BACHILLERATO', "nivel": 'Tercero de Bachillerato' },
   
  ];